import React, { useEffect } from "react";
import { useGetPublicationCalendarQuery } from "../../../../redux/service/modules/dashboard";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useSelector } from "react-redux";
import TableLayout from "../../../../components/layout/TableLayout";

const PublicationCalendar = ({ appliedFilters, setRequiredFilters }) => {
    const dateRange = useSelector((state) => state.date);

    useEffect(() => {
        setRequiredFilters(["analyst"]);
        return () => {
            // Clean up effect when component unmounts
            setRequiredFilters([]);
        };
    }, []);

    return (
        <TableLayout>
            <PaginatedDataTable
                queryHook={useGetPublicationCalendarQuery}
                initialDateRange={dateRange}
                isColumnSticky={true}
                stickyColumnsCount={2}
                appliedFilters={appliedFilters}
                defaultPageSize={100}
                totalText="Overall Total"
            />
        </TableLayout>
    );
};

export default PublicationCalendar;
